export const lang = {
  en: {
    search: "search",
    chats: "Chats",
    groups: "Groups",
    profile: "Profile",
    logout: "Logout",
    contact_info: "Contact Info",
    group_info: "Group Info",
    settings: "Settings",
    members: "Members",
    change_picture: "Change Picture",
    remove_picture: "Remove Picture",
    name: "Name",
    status: "Status",
    email: "Email",
    description: "Description",
    create_group: "Create Group",
    group_details: "Group Details",
    enter_group_name: "Enter Group Name",
    enter_group_description: "Enter Group Description",
    typing: "Typing",
    message: "Type a message",
    files: "Files",
    Images_videos: "Images & Videos",
    select_language: "Select Language",
    no_user: "no user",
    you: "You",
    add_caption: "Add caption",
    remove_picture: "Remove Picture ?",
    yesterday: "Yesterday",
    Just_now: "Just now",
    calling: "Calling",
    User_is_offline: "User is offline",
    is_calling: "is calling...",
    fusion: "Fusion",
    Name_should_be_atleast_2_characters: "Name should be atleast 2 characters",
    Name_should_not_exceed_20_characters:
      "Name should not exceed 20 characters",
    Status_should_not_exceed_20_characters:
      "Status should not exceed 20 characters",

    Group_name_cannot_be_empty: "Group name cannot be empty",
    Group_name_should_be_atleast_2_characters:
      "Group name should be atleast 2 characters",
    Group_name_should_not_exceed_20_characters:
      "Group name should not exceed 20 characters",
    Group_description_should_not_exceed_20_characters:
      "Group description should not exceed 20 characters",
  },
  hi: {
    search: "खोज",
    chats: "चैट",
    groups: "समूह",
    profile: "प्रोफ़ाइल",
    logout: "लॉग आउट",
    contact_info: "संपर्क सूचना",
    group_info: "समूह जानकारी",
    settings: "समायोजन",
    members: "सदस्यों",
    change_picture: "चित्र बदलें",
    remove_picture: "चित्र हटाएँ",
    name: "नाम",
    status: "स्थिति",
    email: "ईमेल",
    description: "विवरण",
    create_group: "समूह बनाना",
    group_details: "समूह विवरण",
    enter_group_name: "समूह का नाम दर्ज करें",
    enter_group_description: "समूह विवरण दर्ज करें",
    typing: "टाइपिंग",
    message: "एक संदेश लिखें",
    files: "फ़ाइलें",
    Images_videos: "छवियाँ और वीडियो",
    select_language: "भाषा चुने",
    no_user: "उपयोगकर्ता नहीं मिला",
    you: "आप",
    add_caption: "कैप्शन जोड़ें",
    remove_picture: "चित्र हटाएँ ?",
    yesterday: "कल",
    Just_now: "अभी",
    calling: "कॉलिंग",
    User_is_offline: "उपयोगकर्ता ऑफ़लाइन है",
    is_calling: "कॉल कर रहा है...",
    fusion: "फ्यूज़न",
    Name_should_be_atleast_2_characters: "नाम कम से कम 2 अक्षर का होना चाहिए",
    Name_should_not_exceed_20_characters:
      "नाम 20 अक्षरों से अधिक नहीं होना चाहिए",
    Status_should_not_exceed_20_characters:
      "स्थिति 20 अक्षरों से अधिक नहीं होनी चाहिए",

    Group_name_cannot_be_empty: "समूह का नाम खाली नहीं हो सकता",
    Group_name_should_be_atleast_2_characters:
      "ग्रुप का नाम कम से कम 2 अक्षर का होना चाहिए",
    Group_name_should_not_exceed_20_characters:
      "समूह का नाम 20 अक्षरों से अधिक नहीं होना चाहिए",
    Group_description_should_not_exceed_20_characters:
      "समूह विवरण 20 अक्षरों से अधिक नहीं होना चाहिए",
  },

  //chinese
  zh: {
    search: "搜索",
    chats: "聊天",
    groups: "团体",
    profile: "轮廓",
    logout: "登出",
    contact_info: "联系方式",
    group_info: "群组信息",
    settings: "设置",
    members: "会员",
    change_picture: "更换图片",
    remove_picture: "删除图片",
    name: "姓名",
    status: "地位",
    email: "电子邮件",
    description: "描述",
    create_group: "创建组",
    group_details: "团体详情",
    enter_group_name: "输入群组名称",
    enter_group_description: "输入群组描述",
    typing: "打字",
    message: "信息",
    files: "文件",
    Images_videos: "图片和视频",
    select_language: "选择语言",
    no_user: "没有用户",
    you: "你",
    add_caption: "添加字幕",
    remove_picture: "删除图片 ?",
    yesterday: "昨天",
    Just_now: "现在",
    calling: "呼叫",
    User_is_offline: "用户离线",
    is_calling: "正在打电话...",
    fusion: "融合",
    Name_should_be_atleast_2_characters: "名称至少应包含 2 个字符",
    Name_should_not_exceed_20_characters: "名称不得超过 20 个字符",
    Status_should_not_exceed_20_characters: "状态不应超过 20 个字符",

    Group_name_cannot_be_empty: "群组名称不能为空",
    Group_name_should_be_atleast_2_characters: "群组名称应至少为 2 个字符",
    Group_name_should_not_exceed_20_characters: "群组名称不得超过 20 个字符",
    Group_description_should_not_exceed_20_characters:
      "群组描述不应超过 20 个字符",
  },
  //spanish
  es: {
    search: "buscar",
    chats: "charlas",
    groups: "grupos",
    profile: "perfil",
    logout: "cerrar sesión",
    contact_info: "Datos de contacto",
    group_info: "información_grupo",
    settings: "ajustes",
    members: "miembros",
    change_picture: "cambiar imagen",
    remove_picture: "eliminar imagen",
    name: "nombre",
    status: "estado",
    email: "correo electrónico",
    description: "descripción",
    create_group: "crea un grupo",
    group_details: "detalles_del_grupo",
    enter_group_name: "Introduzca el nombre del grupo",
    enter_group_description: "Ingrese la descripción del grupo",
    typing: "mecanografía",
    message: "Escribe un mensaje",
    files: "Archivos",
    Images_videos: "Imágenes y vídeos",
    select_language: "Seleccione el idioma",
    no_user: "ningún usuario",
    you: "Tú",
    add_caption: "Añadir un subtitulo",
    remove_picture: "eliminar imagen?",
    yesterday: "ayer",
    Just_now: "En este momento",
    calling: "vocación",
    User_is_offline: "El usuario está desconectado",
    is_calling: "esta llamando...",
    fusion: "Fusión",
    Name_should_be_atleast_2_characters:
      "El nombre debe tener al menos 2 caracteres.",
    Name_should_not_exceed_20_characters:
      "El nombre no debe exceder los 20 caracteres.",
    Status_should_not_exceed_20_characters:
      "El estado no debe exceder los 20 caracteres.",

    Group_name_cannot_be_empty: "El nombre del grupo no puede estar vacío",
    Group_name_should_be_atleast_2_characters:
      "El nombre del grupo debe tener al menos 2 caracteres.",
    Group_name_should_not_exceed_20_characters:
      "El nombre del grupo no debe exceder los 20 caracteres.",
    Group_description_should_not_exceed_20_characters:
      "La descripción del grupo no debe exceder los 20 caracteres.",
  },
};
